var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61317 8.97549C1.52238 8.83173 1.47698 8.75985 1.45157 8.64898C1.43248 8.56571 1.43248 8.43437 1.45157 8.3511C1.47698 8.24023 1.52238 8.16835 1.61317 8.02459C2.36344 6.8366 4.59669 3.83337 8.00002 3.83337C11.4034 3.83337 13.6366 6.8366 14.3869 8.02459C14.4777 8.16835 14.5231 8.24023 14.5485 8.3511C14.5676 8.43437 14.5676 8.56571 14.5485 8.64898C14.5231 8.75985 14.4777 8.83173 14.3869 8.97549C13.6366 10.1635 11.4034 13.1667 8.00002 13.1667C4.59669 13.1667 2.36344 10.1635 1.61317 8.97549Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5C9.10457 10.5 10 9.60457 10 8.5C10 7.39543 9.10457 6.5 8 6.5C6.89543 6.5 6 7.39543 6 8.5C6 9.60457 6.89543 10.5 8 10.5Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.80b5e874102fb5c93283f6670e0ffb8c.svg";
export { ForwardRef as ReactComponent };